import { useEffect, useState, useRef } from 'react';

import { useParams, useNavigate, Link } from 'react-router-dom';
import API from '../utils/api';
import toast from 'react-hot-toast';
import { useAuth } from '../context/AuthContext';
import { getErrorMessage } from '../utils/errors';



export default function VerifyEmail() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { user, loading, refreshUser } = useAuth();
  const [status, setStatus] = useState('verifying'); // verifying, success, error

  const hasRun = useRef(false);

  useEffect(() => {
    // Wait for the session check so we know whether to refresh the signed-in user afterwards
    if (loading || hasRun.current) return;
    hasRun.current = true;

    API.get(`/auth/verify/${token}`)
      .then(async () => {
        setStatus('success');
        if (user) await refreshUser(true).catch(() => {});
      })
      .catch((e) => {
        setStatus('error');
        toast.error(getErrorMessage(e, 'Verification failed'));
      });
  }, [token, loading]); // eslint-disable-line





  return (
    <div className="auth-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '80vh' }}>
      <div className="card modal-sm" style={{ width: '100%', textAlign: 'center', padding: 'var(--spacing-md, 32px) var(--spacing-sm, 24px)' }}>
        {status === 'verifying' && (
          <>
            <div className="skeleton" style={{ width: 60, height: 60, borderRadius: '50%', margin: '0 auto 24px' }} />
            <h1 style={{ marginBottom: 12 }}>Verifying your email...</h1>
            <p style={{ color: 'rgba(13,13,13,0.5)', fontSize: 14 }}>One moment while we confirm your address.</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div style={{ fontSize: 64, marginBottom: 20 }}>✅</div>
            <h1 style={{ marginBottom: 12 }}>Email Verified!</h1>
            <p style={{ color: 'rgba(13,13,13,0.5)', fontSize: 14, marginBottom: 24 }}>
              Your account is now secure. You can now receive reminders and stay consistent.
            </p>
            <button className="btn btn-primary" onClick={() => navigate(user ? '/dashboard' : '/login')} style={{ width: '100%', justifyContent: 'center' }}>
              {user ? 'Go to Dashboard' : 'Sign in'}
            </button>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={{ fontSize: 64, marginBottom: 20 }}>❌</div>
            <h1 style={{ marginBottom: 12 }}>Verification Failed</h1>
            <p style={{ color: 'rgba(13,13,13,0.5)', fontSize: 14, marginBottom: 24 }}>
              The link may be expired or invalid. Please try sending a new one from your profile.
            </p>
            <Link to={user ? '/profile' : '/login'} className="btn btn-outline" style={{ width: '100%', justifyContent: 'center', textDecoration: 'none' }}>
              {user ? 'Return to Profile' : 'Sign in'}
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
